import { isNumber, isString } from 'util'

const BOARD_LINE_NUM = 15

const STONE_COLOR = {
  NONE: 0,
  BLACK: 1,
  WHITE: 2,
}

const CONVERT_TYPE = {
  ROTATE180: 'ROTATE180',
  ROTATE90_AND_FLIP_HORIZONTAL: 'ROTATE90_AND_FLIP_HORIZONTAL',
  ROTATE90_AND_FLIP_VERTICAL: 'ROTATE90_AND_FLIP_VERTICAL',
  FLIP_HORIZONTAL: 'FLIP_HORIZONTAL',
  FLIP_VERTICAL: 'FLIP_VERTICAL',
}

class FiveMovesValidator {
  constructor() {
    var x, y
    this.arrayBoard = new Array(BOARD_LINE_NUM * BOARD_LINE_NUM)
    for (y = 0; y < BOARD_LINE_NUM; y++) {
      for (x = 0; x < BOARD_LINE_NUM; x++) {
        this.arrayBoard[x + y * BOARD_LINE_NUM] = {
          x, y, color: 0
        }
      }
    }
  }

  setMoves(moves, fiveMoves) {
    moves.forEach(move => {
      if (
        isString(move.color) === false || isNumber(move.number) === false ||
        move.number < 1 || move.number > 4
      ) {
        return
      }
      this.arrayBoard[move.x + move.y * BOARD_LINE_NUM].color =
        move.color === 'black' ? STONE_COLOR.BLACK :
        move.color === 'white' ? STONE_COLOR.WHITE : STONE_COLOR.NONE
    })
    fiveMoves.forEach(move => {
      this.arrayBoard[move.x + move.y * BOARD_LINE_NUM].fiveMove = true
    })
  }

  getInvalidFiveMoves() {
    var symmetryMoves, invalidMoves
    invalidMoves = []
    symmetryMoves = this.getSymmetricalFiveMoves()
    symmetryMoves.forEach(moves => {
      moves.forEach(move => {
        if (invalidMoves.some(mv => mv.x === move.x && mv.y === move.y)) {
          return
        }
        invalidMoves.push(move)
      })
    })
    return invalidMoves
  }

  getSymmetricalFiveMoves() {
    var rectProps, convertedBoard, convertedRectProps, fiveMoves, result
    result = []
    rectProps = this.getObjectRectProps(this.arrayBoard)
    // this.printArrayBoard(this.arrayBoard)
    Object.keys(CONVERT_TYPE).forEach(type => {
      convertedBoard = this.convertBoard(type, this.arrayBoard)
      // this.printArrayBoard(convertedBoard)
      convertedRectProps = this.getObjectRectProps(convertedBoard)
      if (convertedRectProps.width !== rectProps.width || convertedRectProps.height !== rectProps.height) {
        return
      }
      if (true === this.compareObject(this.arrayBoard, rectProps, convertedBoard, convertedRectProps)) {
        fiveMoves = this.compareArrayBoard(this.arrayBoard, rectProps, convertedBoard, convertedRectProps)
        result = result.concat(fiveMoves)
      }
    })
    return result
  }

  convertBoard(type, arrayBoard) {
    var temp
    switch(type) {
      case CONVERT_TYPE.ROTATE180:
        return this.rotate180Board(arrayBoard)
      case CONVERT_TYPE.ROTATE90_AND_FLIP_HORIZONTAL:
        temp = this.rotate90Board(arrayBoard)
        return this.flipHorizontalBoard(temp)
      case CONVERT_TYPE.ROTATE90_AND_FLIP_VERTICAL:
        temp = this.rotate90Board(arrayBoard)
        return this.flipVerticalBoard(temp)
      case CONVERT_TYPE.FLIP_HORIZONTAL:
        return this.flipHorizontalBoard(arrayBoard)
      case CONVERT_TYPE.FLIP_VERTICAL:
        return this.flipVerticalBoard(arrayBoard)
      default:
        return []
    }
  }

  rotate180Board(arrayBoard) {
    var result = []
    arrayBoard.forEach(cell => {
      result.unshift(cell)
    })
    return result
  }

  rotate90Board(arrayBoard) {
    var x, y, result
    result = []
    for (x = 0; x < BOARD_LINE_NUM; x++) {
      for (y = 0; y < BOARD_LINE_NUM; y++) {
        result.push(arrayBoard[x + (BOARD_LINE_NUM - 1 - y) * BOARD_LINE_NUM])
      }
    }
    return result
  }

  flipVerticalBoard(arrayBoard) {
    var x, y, result
    result = []
    for (y = 0; y < BOARD_LINE_NUM; y++) {
      for (x = 0; x < BOARD_LINE_NUM; x++) {
        result.push(arrayBoard[x + (BOARD_LINE_NUM - 1 - y) * BOARD_LINE_NUM])
      }
    }
    return result
  }

  flipHorizontalBoard(arrayBoard) {
    var x, y, result
    result = []
    for (y = 0; y < BOARD_LINE_NUM; y++) {
      for (x = 0; x < BOARD_LINE_NUM; x++) {
        result.push(arrayBoard[BOARD_LINE_NUM - 1 - x + y * BOARD_LINE_NUM])
      }
    }
    return result
  }

  getObjectRectProps(arrayBoard) {
    var top, bottom, right, left, x, y
    arrayBoard.forEach((cell, index) => {
      if (cell.color === STONE_COLOR.NONE) {
        return
      }
      x = parseInt(index % BOARD_LINE_NUM, 10)
      y = parseInt(index / BOARD_LINE_NUM, 10)
      top    = top    === undefined ? y : top    > y ? y : top
      bottom = bottom === undefined ? y : bottom < y ? y : bottom
      right  = right  === undefined ? x : right  < x ? x : right
      left   = left   === undefined ? x : left   > x ? x : left
    })
    if (top === undefined || bottom === undefined || right === undefined || left === undefined) {
      return { x: 0, y: 0, width: 0, height: 0 }
    }

    return {
      x: left,
      y: top,
      width: right - left,
      height: bottom - top
    }
  }

  compareObject(arrayBoardA, rectPropsA, arrayBoardB, rectPropsB) {
    var x, y, cellA, cellB
    if (rectPropsA.width !== rectPropsB.width || rectPropsA.height !== rectPropsB.height) {
      return false
    }
    for (y = 0; y < rectPropsA.height; y++) {
      for (x = 0; x < rectPropsA.width; x++) {
        cellA = arrayBoardA[rectPropsA.x + x + (rectPropsA.y + y) * BOARD_LINE_NUM]
        cellB = arrayBoardB[rectPropsB.x + x + (rectPropsB.y + y) * BOARD_LINE_NUM]
        if (cellA.color !== cellB.color) {
          return false
        }
      }
    }
    return true
  }

  compareArrayBoard(arrayBoardA, rectPropsA, arrayBoardB, rectPropsB) {
    var symmetryMoves, upperCut, lowerCut, leftCut, rightCut, cellA, cellB, x, y
    symmetryMoves = []
    upperCut = rectPropsA.y > rectPropsB.y ? rectPropsA.y - rectPropsB.y : 0
    lowerCut = rectPropsA.y < rectPropsB.y ? rectPropsB.y - rectPropsA.y : 0
    leftCut  = rectPropsA.x > rectPropsB.x ? rectPropsA.x - rectPropsB.x : 0
    rightCut = rectPropsA.x < rectPropsB.x ? rectPropsB.x - rectPropsA.x : 0
    for (y = 0 + upperCut; y < BOARD_LINE_NUM - lowerCut; y++) {
      for (x = 0 + leftCut; x < BOARD_LINE_NUM - rightCut; x++) {
        cellA = arrayBoardA[x + y * BOARD_LINE_NUM]
        cellB = arrayBoardB[x - rectPropsA.x + rectPropsB.x + (y - rectPropsA.y + rectPropsB.y) * BOARD_LINE_NUM]        
        if (cellA.color !== cellB.color) {
          return []
        }
        if (this.compareCell(cellA, cellB, symmetryMoves)) {
          symmetryMoves.push([{ x: cellA.x, y: cellA.y }, { x: cellB.x, y: cellB.y }])
        }
      }
    }
    return symmetryMoves
  }

  compareCell(cellA, cellB, symmetryMoves) {
    return Boolean(
      cellA.fiveMove === true && cellB.fiveMove === true &&
      (cellA.x !== cellB.x || cellA.y !== cellB.y) &&
      symmetryMoves.some(moves => {
        return Boolean(
          (moves[1].x === cellA.x && moves[1].y === cellA.y && moves[0].x === cellB.x && moves[0].y === cellB.y) ||
          (moves[0].x === cellA.x && moves[0].y === cellA.y && moves[1].x === cellB.x && moves[1].y === cellB.y)
        )
      }) === false
    )
  }

  printArrayBoard(arrayBoard) {
    var num, strings
    strings = ''
    for (num = 0; num < BOARD_LINE_NUM; num++) {
      strings += this.getRowStrings(arrayBoard, num)
      strings += `\n`
    }
    console.dir(strings)
  }
  
  getRowStrings(arrayBoard, num) {
    var strings
    strings = ''
    arrayBoard
    .slice(num * BOARD_LINE_NUM, (num + 1) * BOARD_LINE_NUM)
    .forEach(cell => {
      strings += cell.fiveMove === true ? '5' :
                 cell.color === STONE_COLOR.NONE  ? '+' :
                 cell.color === STONE_COLOR.BLACK ? '●' :
                 cell.color === STONE_COLOR.WHITE ? '○' : ''
    })
    return strings
  }
}

export default FiveMovesValidator


// WEBPACK FOOTER //
// ./src/lib/FiveMovesValidator.js